import {http} from './config';
export default {

    listarVentas: () => {
        return http.get('api/ventas');
    },

    save: (venta) => {
        return http.post('api/ventas', venta);
    },

    update: (id, payload) => {
        return http.put('api/ventas/' + id, payload);
    },

    delete: (id) => {
        return http.delete('api/ventas/' + id);
    }
}
